<script setup lang="ts" generic="TItem">
import Dropdown from 'primevue/dropdown'

defineProps<{
  items: TItem[]
  displayFunction(item: TItem): string
  itemKey?: string
}>()
const { t } = useI18n()
const model = defineModel<TItem>({
  required: true,
})
</script>

<template>
  <!-- eslint-disable vue/valid-v-model -->
  <Dropdown
    v-model="model" :options="items" aria-labelledby="basic" scroll-height="400px"
  >
    <template #value>
      <slot name="value" :model="model">
        <span v-if="model">{{ displayFunction(model) }}</span>
        <span v-else class="text-gray-400">{{ t('product.select_a_product') }}</span>
      </slot>
    </template>
    <template #option="{ option }">
      <slot name="option" :option="(option as NonNullable<TItem>)">
        <span>{{ displayFunction(option) }}</span>
      </slot>
    </template>
  </Dropdown>
</template>
